export const hasProperty = <T extends Record<string, unknown>>(
  obj: T,
  key: string
): boolean => obj && Object.prototype.hasOwnProperty.call(obj, key);
